import gsap from 'gsap'; 
import { each } from 'lodash';
import { app, menu } from '../../utils/store'
import { activate, deactivate, available, disable } from '../../utils/states'
import { media } from '../../utils/media'


export default class Rooms {
    constructor() {
        this.main = {
            toggler: document.getElementById('menu-toggler'),
            menu: document.getElementById('main-menu'),
            account: document.querySelector('[data-menu-account]'),

        }
        this.rooms = {
            toggler: document.querySelectorAll('[data-target="rooms-menu"]'),
            menu: document.getElementById('rooms-menu'),
            nav: document.querySelector('#rooms-menu [data-menu-products]'),
            list: document.querySelector('#rooms-menu [data-list-products]'),
            buttons: document.querySelectorAll('#rooms-menu li a'),
        }
        this.products = {
            toggler: document.querySelectorAll('[data-target="products-menu"]')
        }

        this.current = {}


        this.toggle();

        each(this.rooms.buttons, (button) => {
            button.onmouseover = this.onMouseHover;
        })
    }

    toggle = () => {
        each(this.rooms.toggler,(toggler) => {
            toggler.addEventListener('click', () => {
                
                var container = document.createElement('div');
                //CONTAINER
                container.classList.add('col-12');
                container.classList.add('col-md-6');
                container.setAttribute('data-preview-rooms','');
                
                this.rooms.list.append(container);
                
                if((!menu.isOpen && menu.current != 'rooms') || (menu.isOpen && menu.current == 'main')){ // if this.isMenuOpen = false
                    this.open();
                    menu.current='rooms'
                    menu.isOpen = true

                    if (!media('>=iPadLandscape')) {
                        this.main.toggler.classList.add('back')
                        menu.isBack = true
                    }
                }
                else{ // if menu.isOpen = true
                    this.close();
                    menu.current = undefined
                    menu.isOpen = false
                }
                
                console.log(menu);
            });
        });
    }

    open = () =>{
        activate(this.main.toggler);
        activate(this.rooms.menu);
        if (media('>=iPadLandscape')) {
            each(this.rooms.toggler,(toggler) => activate(toggler));
            each(this.products.toggler,(toggler) => disable(toggler));
        }
        app.header.classList.add('inverted');
        document.body.classList.add('overflow-hidden');
    }

    close = () =>{
        deactivate(this.main.toggler);
        deactivate(this.rooms.menu);
        if (media('>=iPadLandscape')) {
            each(this.rooms.toggler,(toggler) => deactivate(toggler));
            each(this.products.toggler,(toggler) => available(toggler));
        }
        app.header.classList.remove('inverted');
        document.body.classList.remove('overflow-hidden');
    }

    onMouseHover = (e) => {
        if (!this.isPreview) {
            this.create();
        }

        this.current.postID = e.target.getAttribute('data-id');
        this.current.media = e.target.getAttribute('data-media');
        this.current.title = e.target.getAttribute('data-title');
        this.current.description = e.target.getAttribute('data-description');

        this.preview.description.innerHTML = this.current.description;
        this.preview.title.innerHTML = this.current.title;

        each(this.rooms.buttons,(item) => deactivate(item));
        activate(e.target);

        console.log(this.current)

        if (!this.isAnimatedIn) {
            this.animationIn(this.preview.image, this.current.media, this.preview.box);
        }
        else {
            this.animationOut(this.preview.image, this.current.media, this.preview.box);
        }
    }

    create = () => {
        this.isPreview = true;

        var container = document.querySelector('[data-preview-rooms]'),
            wrapper = document.createElement('div'),
            image = new Image(),
            content = document.createElement('div'),
            title = document.createElement('div'),
            description = document.createElement('p');

        //WRAPPER
        wrapper.classList.add('content-wrapper');
        wrapper.classList.add('d-none');
        wrapper.classList.add('d-xl-flex');
        wrapper.classList.add('align-items-end');
        wrapper.classList.add('position-relative');
        wrapper.setAttribute('data-preview-rooms','');

        //IMAGE
        image.classList.add('media-kind');
        image.classList.add('img-fluid');

        //CONTENT
        content.classList.add('box-text');
        content.setAttribute('data-content','');

        //TITLE
        title.classList.add('d-none');
        title.classList.add('d-md-flex');
        title.classList.add('mb-4');
        title.classList.add('title');
        title.classList.add('h5');
        title.setAttribute('data-title','');

        //DESCRIPTION
        description.classList.add('description');
        description.classList.add('mb-4');
        description.setAttribute('data-description','');

        content.append(title);
        content.append(description);

        wrapper.append(image);
        wrapper.append(content);

        container.append(wrapper);

        this.rooms.list.append(container);

        this.preview = {
            main: this.rooms.menu.querySelector('[data-preview-rooms]'),
            box: this.rooms.menu.querySelector('[data-content]'),
            image: this.rooms.menu.querySelector('[data-preview-rooms] img'),
            title: this.rooms.menu.querySelector('[data-preview-rooms] [data-title]'),
            description: this.rooms.menu.querySelector('[data-preview-rooms] [data-description]')
        }

        //START POINT FROM ANIMATION GSAP
        gsap.set(this.preview.image , {
            x: -50,
            autoAlpha: 0,          
        })

        gsap.set(this.preview.box , {
            x: 100,
            autoAlpha: 0,    
        })
    }

    //ANIMATION IN GSAP
    animationIn(image, dataSrc, container){
        gsap.to(image, {
            delay: .25,
            duration: 1,
            x: 0,
            autoAlpha: 1,
            onStart: () => {
                this.isAnimatedIn = true;
                dataSrc ? (this.preview.image.src = dataSrc) : null;
            },
            onComplete: () =>{
                
            },
        })

        gsap.to(container, {
            duration: 1,
            x: 60,
            autoAlpha: 1,
            onComplete: () =>{
                container ? (this.preview.box = container) : null;
            },
        })
    }

    //ANIMATION OUT GSAP
    animationOut(image, dataSrc = null, container){
        gsap.to(image, {
            duration: 1,
            x: -50,
            autoAlpha: 0,
            onComplete: () => {
                this.isAnimatedIn = false;
                this.preview.image.src = '';
                this.animationIn(image, dataSrc, container);
            }
        })

        gsap.to(container, {
            duration: 1,
            x: 100,
            autoAlpha: 0
        })
    }
}
